import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'

export type RelationManagerProps = ModelProps<RelationManager>

export default class RelationManager extends Model<RelationManager> {
  static readonly none = new RelationManager()

  @observable
  accessor id = Id.none

  @observable
  accessor firstName = ''

  @observable
  accessor lastName = ''

  @observable
  accessor fullName = ''

  @observable
  accessor email: string | null = null

  @observable
  accessor meetingLink: string | null = null

  @observable
  accessor phoneNumber: string | null = null

  @observable
  accessor avatarUrl: string | null = null

  @observable
  accessor isAvailable = true
}
